import React from "react";

function Home(props) {
  return <div />;
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.jsx